import React, { useEffect, useState } from 'react'
import SALink from 'components/SALink'
import styles from './Account.module.scss'
import classNames from 'classnames'
import { useHeaderContext } from '../../HeaderContext'
import { useDispatch } from 'react-redux'
import { Modals } from 'types/Authentication'
import { Actions as ModalActions } from 'actions/shared/modal'

type Props = {
  dropdownIsOpen: boolean
  dropdownIsHovered: boolean
}

const AuthLinksDropDown = (props: Props) => {
  const dispatch = useDispatch()
  const { dropdownIsOpen, dropdownIsHovered } = props
  const { mobileHeaderConfig, setMobileHeaderConfig } = useHeaderContext()

  const [location, updateLocation] = useState('/')

  const openModal = (name: Modals) => {
    dispatch(ModalActions.OPEN_MODAL(name))
  }

  useEffect(() => {
    const { href } = window.location
    updateLocation(href)
  })

  return (
    <div
      className={classNames(styles.accountDropDownContent, styles.accountDropDownContentAuth, {
        [styles.accountDropDownContentOpen]:
          dropdownIsOpen ||
          dropdownIsHovered ||
          (mobileHeaderConfig.isMobileMenuOpen && mobileHeaderConfig.mobileMenuContent === 'auth'),
      })}
    >
      <SALink
        data-gtm-event='top-nav'
        className={classNames('defaultTypographyMedium', styles.accountDropDownContentAuthLink)}
        href={`/authentication/?redirect_url=${encodeURIComponent(location)}`}
        onClick={(ev: React.SyntheticEvent<Record<string, any>>) => {
          ev.preventDefault()
          openModal('login')
          setMobileHeaderConfig((previousMobileHeaderConfig) => ({
            ...previousMobileHeaderConfig,
            mobileTopHeader: 'mainTopHeader',
            isMobileMenuOpen: false,
          }))
        }}
        rel='nofollow'
      >
        Log In
      </SALink>

      <SALink
        data-gtm-event='top-nav'
        className={classNames('defaultTypographyMedium', styles.accountDropDownContentAuthLink)}
        href={`/authentication/register/?redirect_url=${encodeURIComponent(location)}`}
        onClick={(ev: React.SyntheticEvent<Record<string, any>>) => {
          ev.preventDefault()
          openModal('register')
          setMobileHeaderConfig((previousMobileHeaderConfig) => ({
            ...previousMobileHeaderConfig,
            mobileTopHeader: 'mainTopHeader',
            isMobileMenuOpen: false,
          }))
        }}
        rel='nofollow'
      >
        Register
      </SALink>
    </div>
  )
}

export default AuthLinksDropDown
